export const KEY = {
  // rongCloudAppKey: 'cpj2xarlctnfn' //测试环境&本地开发
  // rongCloudAppKey: 'sfci50a7s3khi' //本地开发
  rongCloudAppKey: 'y745wfm8yqvzv' //正式环境 运营版
   //rongCloudAppKey: '8luwapkv8bu6l' //政府版key
}



// WEBPACK FOOTER //
// ./src/config/index.js